export const SPADES_SUIT = "SPADES";
export const CROSS_SUIT = "CROSS";
export const DIAMONDS_SUIT = "DIAMONDS";
export const HEARTS_SUIT = "HEARTS";
export const EASY_MODE_LIVES = 3;
export const DEFAULT_MODE_LIVES = 1;
